import { Masonry } from "@mui/lab"
import { Box } from "@mui/material"

import BlogArticleTeaser, {
  type BlogArticleTeaserProps,
} from "../BlogArticleTeaser/BlogArticleTeaser"
import { FC } from ".."

type BlogArticleCollectionProps = {
  items: BlogArticleTeaserProps[]
  onLike?: (arg: { contentType?: string; nid?: number }, arg2?: string) => void
  onUnlike?: (arg: { contentType?: string; nid?: number }, arg2?: string) => void
}

const BlogArticleCollection: FC<BlogArticleCollectionProps> = ({
  items = [],
  onLike,
  onUnlike,
}) => {
  return (
    <Box m={{ xs: -2, md: -5 }}>
      <Masonry columns={{ xs: 1, md: 2, xl: 3 }}>
        {items?.map((item, i) => (
          <Box key={i} p={{ xs: 2, md: 5 }}>
            <BlogArticleTeaser {...item} onLike={onLike} onUnlike={onUnlike} />
          </Box>
        ))}
      </Masonry>
    </Box>
  )
}
export default BlogArticleCollection
